import { parseBoolean } from '@chatwoot/utils';
import { resolveMaximumFileUploadSize } from 'shared/helpers/FileHelper';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  AGENT_NAME: agentName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  SUPPORT_WIDGET_BASE_URL: supportWidgetBaseUrl,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  MAXIMUM_FILE_UPLOAD_SIZE: maximumFileUploadSize,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
  CAPTAIN_ICON_URL: captainIconUrl,
  CAPTAIN_ICON_DARK_URL: captainIconDarkUrl,
  SIDEBAR_SECTION_KANBAN_PANEL: sidebarSectionKanbanPanel,
  SIDEBAR_SECTION_CONVERSATION_ACTIONS: sidebarSectionConversationActions,
  SIDEBAR_SECTION_MACROS: sidebarSectionMacros,
  SIDEBAR_SECTION_AI_AGENTS: sidebarSectionAiAgents,
  SIDEBAR_SECTION_CONVERSATION_INFO: sidebarSectionConversationInfo,
  SIDEBAR_SECTION_CONTACT_ATTRIBUTES: sidebarSectionContactAttributes,
  SIDEBAR_SECTION_CONTACT_NOTES: sidebarSectionContactNotes,
  SIDEBAR_SECTION_PREVIOUS_CONVERSATION: sidebarSectionPreviousConversation,
  SIDEBAR_SECTION_CONVERSATION_PARTICIPANTS: sidebarSectionConversationParticipants,
  SIDEBAR_SECTION_LINEAR_ISSUES: sidebarSectionLinearIssues,
  SIDEBAR_SECTION_SHOPIFY_ORDERS: sidebarSectionShopifyOrders,
} = window.globalConfig || {};

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName,
  agentName: (agentName && typeof agentName === 'string' && agentName.trim()) || 'Agente Assistant',
  chatwootInboxToken,
  supportWidgetBaseUrl,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  maximumFileUploadSize: resolveMaximumFileUploadSize(maximumFileUploadSize),
  hCaptchaSiteKey,
  installationName,
  logo,
  logoDark,
  logoThumbnail,
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
  captainIconUrl,
  captainIconDarkUrl,
  // v6.4.34: Sidebar section visibility gating (per installation)
  sidebarSections: {
    kanban_panel: parseBoolean(sidebarSectionKanbanPanel ?? true),
    conversation_actions: parseBoolean(sidebarSectionConversationActions ?? true),
    macros: parseBoolean(sidebarSectionMacros ?? true),
    ai_agents: parseBoolean(sidebarSectionAiAgents ?? true),
    conversation_info: parseBoolean(sidebarSectionConversationInfo ?? true),
    contact_attributes: parseBoolean(sidebarSectionContactAttributes ?? true),
    contact_notes: parseBoolean(sidebarSectionContactNotes ?? true),
    previous_conversation: parseBoolean(sidebarSectionPreviousConversation ?? true),
    conversation_participants: parseBoolean(sidebarSectionConversationParticipants ?? true),
    linear_issues: parseBoolean(sidebarSectionLinearIssues ?? true),
    shopify_orders: parseBoolean(sidebarSectionShopifyOrders ?? true),
  },
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  isACustomBrandedInstance: $state => $state.installationName !== 'Plataforma',
  isAChatwootInstance: $state => $state.installationName === 'Plataforma',
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
